import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LocationsService {
  public locations: any[] = [];
}
